module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ONE")]), _c('br'), _vm._v("The Hinge of Fate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('em', [_vm._v("The turning point. Two accounts. – The awesomeness of the"), _c('br'), _vm._v("German tide. – Black Fortnight. – Problems of British"), _c('br'), _vm._v("morale. – Distrust of Churchill. – Opinions and sentiments. – "), _c('br'), _vm._v("“Outwardly calm, inwardly anxious.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWO")]), _c('br'), _vm._v("Friday, 24 May")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('em', [_vm._v("Hitler’s halt order. – The Germans before"), _c('br'), _vm._v("Dunkirk. – Calais. – Hitler and the Conservatives. – The two"), _c('br'), _vm._v("Rights. – Chamberlain. -Appeasers. – Halifax. – The War"), _c('br'), _vm._v("Cabinet. – Churchill and Roosevelt. – The British press. – "), _c('br'), _vm._v("“A slight increase in anxiety and a slight"), _c('br'), _vm._v("decrease in optimism.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THREE")]), _c('br'), _vm._v("Saturday, 25 May")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('em', [_vm._v("An English weekend. – The French: Weygand and"), _c('br'), _vm._v("Pétain. – Halifax and the Italian ambassador. – Churchill and"), _c('br'), _vm._v("the Defence Committee. – “Depression is quite definitely up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOUR")]), _c('br'), _vm._v("Sunday, 26 May")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('em', [_vm._v("An agitated day. – Three meetings of the War Cabinet. –"), _c('br'), _vm._v("Chamberlain, Halifax, Churchill. – Disagreements between"), _c('br'), _vm._v("Halifax and Churchill. – Scarcity of news: “A mandate to delay"), _c('br'), _vm._v("judgment and not to worry” – “In Westminster Abbey.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIVE")]), _c('br'), _vm._v("Monday, 27 May")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('em', [_vm._v("What was happening at Dunkirk. – The Belgians"), _c('br'), _vm._v("surrender. – American considerations. – Three War Cabinets"), _c('br'), _vm._v("and a walk in the garden.—“You’d have been better"), _c('br'), _vm._v("off playing cricket.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SIX")]), _c('br'), _vm._v("Tuesday, 28 May")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('em', [_vm._v("Momie, opinion, and the press. – “We cannot possibly starve"), _c('br'), _vm._v("the public in this way.” – Foreigners and refugees. – Churchill’s"), _c('br'), _vm._v("instructions and the first War Cabinet. – His statement in the"), _c('br'), _vm._v("Commons. – The second War Cabinet. – Churchill’s coup-"), _c('br'), _vm._v("He comes through")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEVEN")]), _c('br'), _vm._v("Survival")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('em', [_vm._v("A long-range view of the war. – The meaning of Dunkirk")]), _vm._v(". – "), _c('br'), _c('em', [_vm._v("“It is time to face up to facts” – Halifax redux. – An"), _c('br'), _vm._v("antiquated Britain. – Churchill and Europe")]), _vm._v(". – Fortissimo.")]), _vm._v(" "), _c('p', {
    staticClass: "toc-back1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/biblio#biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/illust#illust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0